// @flow

import { backendAxios } from './axios-config';
import { isEmpty } from 'lodash';

import type { Moment } from 'moment';

import CustomError from '../utils/error';
import { dateToString } from '../utils/date';

const { REACT_APP_WB_BACKEND_URL } = process.env;

export const getPerformance = (
  policyId: string,
  dateAsAt: Moment,
  currencyId: number,
) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  const dateStr = dateToString(dateAsAt);

  return backendAxios.get(`/policies/${policyId}/performance?date=${dateStr}&currencyId=${currencyId}`);
};

export const getRiskReturnPerformance = (
  policyId: string,
  dateAsAt: Moment,
) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  const params = { date: dateToString(dateAsAt) };

  return backendAxios.get(`/policies/${policyId}/performance/risk-return`, {
    params,
  });
};
